export default "__VITE_ASSET__CDaBJ3zA__"